import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import Typography from "@mui/material/Typography";

import RouterLink from "../../../../common/components/RouterLink";
import { RouteEnum } from "../../../../common/models/enums";
import DataHubGridItem from "./DataHubGridItem";

const LiveViewPtControlGridItem = (): JSX.Element => {
  return (
    <RouterLink to={RouteEnum.LiveView}>
      <DataHubGridItem
        sx={{
          height: { xs: "80px", sm: "120px", md: "120px", lg: "80px" },
        }}
      >
        <VideoCameraFrontIcon color="primary" />
        <Typography variant="body1">Live View / PT Control</Typography>
      </DataHubGridItem>
    </RouterLink>
  );
};

export default LiveViewPtControlGridItem;
